import fetch from "node-fetch";
import { auth, database, regularAuth } from "../firebase";
import * as moment from "moment";

export const fetchGeolocation = async (id) => {
  try {
    const response = await fetch(
      `https://pro.ip-api.com/json/?key=${process.env.REACT_APP_LOCATION_API_KEY}`
    );
    const data = await response.json();
    const login = {
      as: data.as,
      city: data.city,
      country: data.country,
      countryCode: data.countryCode,
      isp: data.isp,
      lat: data.lat,
      lon: data.lon,
      query: data.query,
      timezone: data.timezone,
      zip: data.zip,
      timestamp: moment().unix(),
    };
    await database.collection("users").doc(id).collection("logins").add(login);
    return { error: null, payload: "success" };
  } catch (e) {
    throw new Error(e);
  }
};

export const regularLogin = async (user) => {
  try {
    const login = await auth.signInWithEmailAndPassword(
      user.email,
      user.password
    );
    if (login) {
      const target = await database
        .collection("users")
        .doc(login.user.uid)
        .get();
      if (target.exists) {
        await fetchGeolocation(login.user.uid);
        return { error: null, payload: "success" };
      }
    } else {
      return { error: "not verified", payload: null };
    }
  } catch (e) {
    if (e && e.code) {
      if (e.code === "auth/wrong-password") {
        throw new Error("Feil brukernavn eller passord.");
      } else {
        throw new Error("Feil brukernavn eller passord.");
      }
    } else {
      throw new Error("Kunne ikke autorisere bruker.");
    }
  }
};

export const googleLogin = async () => {
  try {
    const provider = new regularAuth.GoogleAuthProvider();
    const login = await auth.signInWithPopup(provider);
    const target = await database.collection("users").doc(login.user.uid).get();
    if (target.exists) {
      return {
        error: null,
        payload: { user: login.user, destination: "dashboard" },
      };
    } else {
      return {
        error: null,
        payload: { user: login.user, destination: "register" },
      };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const performResetEmail = async (info) => {
  try {
    await auth.sendPasswordResetEmail(info.email);
    return { error: null, payload: "success" };
  } catch (e) {
    if (e.code) {
      switch (e.code) {
        case "auth/user-not-found":
          throw new Error("Denne e-posten er ikke registrert.");
        default:
          throw new Error("Kunne ikke sende e-post for tilbakestilling.");
      }
    } else {
      throw new Error("Kunne ikke sende e-post for tilbakestilling.");
    }
  }
};
export const performLogout = async () => {
  try {
    await auth.signOut();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
